<ul class="ob1-item-card-list mb-0">
  @for (alert of alerts; track alert) {

    <li class="pt-2">
      <ng-container
        [ngTemplateOutlet]="alert.link ? interactiveAlert : simpleAlert"
        [ngTemplateOutletContext]="{ alert: alert }"
      >
      </ng-container>
    </li>
  }
</ul>

<ng-template #interactiveAlert let-alert="alert">
  <div class="alert-container ob1-notification-message alert-danger" [attr.data-e2e]="'e2e-push-alerts-' + alert?.code">
    <a
      ecmPushTracker
      [ecmDisabledAction]="isEclair && !AdviseWhitelistEclairConstants.WHITELIST.includes(alert.code?.toUpperCase())"
      [attr.data-e2e]="'e2e-push-alerts-btn-' + alert?.code"
      [attr.id-ref-zone]="alert?.idRefZone"
      [pdb-zid]="zid"
      [pdb-sc]="'adv'"
      [pdb-ta]="alert.advTracker"
      [pdb-idc]="alert.code"
      [href]="alert.href"
      (click)="openLink(alert); (false)"
      class="ob1-item-card alert-danger px-1 px-md-1 no-border"
    >
      <span class="ob1-item-card-icon push-alert-icon icon-error-severe" aria-hidden="true"></span>
      <div class="ob1-item-card-container anchor-color">
        <div class="ob1-item-card-text">
          <strong>{{ alert.title }}</strong>
          <small class="ob1-item-card-desc push-alert-desc text-mw">
            {{ alert.content }}
          </small>
        </div>
      </div>
    </a>
  </div>
</ng-template>

<ng-template #simpleAlert let-alert="alert">
  <div
    class="alert-container ob1-notification-message alert-danger disable-hover"
    [attr.data-e2e]="'e2e-push-alerts-' + alert?.code"
  >
    <div class="ob1-item-card alert-danger no-border">
      <span class="ob1-item-card-icon push-alert-icon icon-error-severe" aria-hidden="true"></span>
      <div class="ob1-item-card-container py-0">
        <div class="ob1-item-card-text">
          <strong>{{ alert.title }}</strong>
          <small class="ob1-item-card-desc push-alert-desc text-mw text-dark" [innerHTML]="alert.content"> </small>
        </div>
      </div>
    </div>
  </div>
</ng-template>
